import api from '@/lib/calendesk-js-library/api/api'
import { ActionTree } from 'vuex'
import { RootState } from '../../types'
import { DomainSelect } from './types'
import Domain from '@/calendesk/models/DTO/Response/Domain'
import { plainToClass } from 'class-transformer'
import Draft from '@/calendesk/models/DTO/Response/Draft'

export const actions: ActionTree<DomainSelect, RootState> = {
  fetch ({ rootGetters, commit }, data: Record<string, any>): Promise<Domain[]> {
    return new Promise((resolve, reject) => {
      // Always the full list: the default page size (25) can miss the domain
      // pinned to the open draft, and the preview bar then claims there is no
      // domain even though the sites list shows one.
      api.getDomains({ limit: 9999, ...data })
        .then((response: any) => {
          const domains = plainToClass(Domain, response.data.data as Domain[])
          const draft: Draft | null = rootGetters['builder/getDraft']
          commit('SET_DOMAINS', domains)

          if (domains.length > 0 && draft) {
            const domain = domains.find((domain) => domain.draftUuid === draft.uuid)
            commit('SET_DEFAULT_DOMAIN', domain || null)
          } else {
            commit('SET_DEFAULT_DOMAIN', null)
          }
          resolve(domains)
        })
        .catch((error: any) => {
          reject(error)
        })
    })
  },
  update ({ rootGetters, dispatch }, domain: Domain): Promise<Domain> {
    return new Promise((resolve, reject) => {
      const draft: Draft | null = rootGetters['builder/getDraft']

      api.updateDomain(domain.id, {
        domain: domain.domain,
        draft_uuid: draft?.uuid
      })
        .then((response: any) => {
          dispatch('fetch').finally(() => {
            const domain = plainToClass(Domain, response.data)
            resolve(domain)
          })
        })
        .catch((error: any) => {
          reject(error)
        })
    })
  },
  add ({ rootGetters, dispatch }, domain: string): Promise<Domain> {
    return new Promise((resolve, reject) => {
      const draft: Draft | null = rootGetters['builder/getDraft']

      api.addDomain({
        domain: domain,
        draft_uuid: draft?.uuid
      })
        .then((response: any) => {
          dispatch('fetch').finally(() => {
            const domain = plainToClass(Domain, response.data)
            resolve(domain)
          })
        })
        .catch((error: any) => {
          reject(error)
        })
    })
  },
  remove ({ dispatch }, id: number): Promise<void> {
    return new Promise((resolve, reject) => {
      api.removeDomain(id)
        .then(() => {
          dispatch('fetch').finally(() => {
            resolve()
          })
        })
        .catch((error: any) => {
          reject(error)
        })
    })
  }
}
